module.exports = __webpack_public_path__ + "5dc164ae304ca34bca1189b19a6c7e04.png";